module.exports = "/assets/data/e5e542d302e0a91c2b05213d9fa0a4f3-NN11.data.json";